/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProviderAvailabilityView } from '../models/ProviderAvailabilityView';
import type { ProviderScheduleCreate } from '../models/ProviderScheduleCreate';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SchedulesService {

    /**
     * @returns ProviderAvailabilityView
     * @throws ApiError
     */
    public static schedulesList({
        dateMax,
        dateMin,
        provider,
    }: {
        dateMax: string,
        dateMin: string,
        provider: Array<string>,
    }): CancelablePromise<Array<ProviderAvailabilityView>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/schedules/',
            query: {
                'date_max': dateMax,
                'date_min': dateMin,
                'provider': provider,
            },
        });
    }

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static schedulesCreate({
        requestBody,
    }: {
        requestBody: ProviderScheduleCreate,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/schedules/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public static schedulesDestroy({
        dates,
        provider,
    }: {
        dates: Array<string>,
        provider: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/schedules/',
            query: {
                'dates': dates,
                'provider': provider,
            },
        });
    }

}
